import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core'

import { FiltroExtrato } from '../shared/filtro-extrato'
import { ExtratoDeAntecipacoes } from '../../pkw-data/collect/extrato/extrato-de-antecipacoes.model'
import { Agrupamento } from '../../pkw-data/collect/extrato/agrupamento.model'
import { Antecipacao } from '../../pkw-data/collect/extrato/antecipacao.model'
import { ExtratoDeAntecipacoesService } from './shared/extrato-de-antecipacoes.service'
import { Agrupador } from '../../pkw-data/collect/extrato/agrupador.enum'

@Component({
    selector: 'col-extratos-de-antecipacoes',
    templateUrl: './extratos-de-antecipacoes.component.html',
    styleUrls: ['../extratos.component.scss']
})
export class ExtratosDeAntecipacoesComponent implements OnInit, OnChanges {
    @Input() filtro: FiltroExtrato

    @Output() extratoObtido = new EventEmitter<ExtratoDeAntecipacoes>()

    extrato: ExtratoDeAntecipacoes
    agrupamento: Agrupamento<Antecipacao>
    totalAntecipado: number
    possuiDados: boolean
    extratoCarregado: boolean
    detalheExpandido: boolean
    agrupador: number
    agrupadorOperadora = Agrupador.Operadora.id 
    agrupadorEstabelecimento = Agrupador.Estabelecimento.id  

    constructor(private extratoDeAntecipacoesService: ExtratoDeAntecipacoesService) {}

    ngOnInit() {
        this.extratoCarregado = false
        this.possuiDados = false
        this.detalheExpandido = false
    }

    ngOnChanges() {
        if (this.filtro) {
            this.agrupador = this.filtro.agrupador
            this.obterExtrato()
        }
    }

    obterExtrato() {
        this.extratoDeAntecipacoesService
            .pesquisar(this.filtro.toFilter())
            .subscribe(extratos => {
                this.esconderDatelhe()
                this.extrato = extratos[0]
                this.extratoCarregado = true
                this.possuiDados = this.extrato && this.extrato.agrupamentos.length > 0
                this.totalAntecipado = this.calcularTotalAntecipado()
                this.extratoObtido.emit(this.extrato)
            })
    }

    exibirDetalhe(agrupamento: Agrupamento<Antecipacao>) {
        if (this.agrupamento === agrupamento) {
            this.detalheExpandido = !this.detalheExpandido
        } else {
            this.agrupamento = agrupamento
            this.detalheExpandido = true
        }
    }

    agenteIsValido(agrupamento: Agrupamento<Antecipacao>): Boolean {
        const isValido = !!agrupamento.estabelecimento && !!agrupamento.estabelecimento.agente && !!agrupamento.estabelecimento.agente.operadoraDeMaquina;
        return isValido;
    }

    private calcularTotalAntecipado() {
        if (!this.possuiDados) {
            return null
        }

        return this.extrato.agrupamentos.reduce((total, agrupamento) => {
            return total + agrupamento.transacao.valorDaAntecipacao
        }, 0)
    }

    private esconderDatelhe() {
        this.agrupamento = undefined
        this.detalheExpandido = false
    }
    
}



// WEBPACK FOOTER //
// ./src/app/extratos/extratos-de-antecipacoes/extratos-de-antecipacoes.component.ts